import axios from '@/util/request'
const baseURL = process.env.VUE_APP_API_URL

export default {
  // 产品页面列表
  addCertification: data => axios({ baseURL, url: '/api/store/certification', data, method: 'post' }), // 新增或编辑客户认证资料
  getCertificationInfo: userId => axios({ baseURL, url: `/api/store/certification/${userId}`, method: 'GET' }), // 新增或编辑客户认证资料
  uploadUniversalFile: data => axios({ baseURL, url: `/api/hbo/uploadUniversalFile`, method: 'POST', data }), // 上传通用文件
  createLoginLog: data => axios({ baseURL, url: `/api/store/user/loginLog`, method: 'POST', data }), // 新增登录日志信息
  getLoginLogs: userId => axios({ url: `/api/store/loginLogs/${userId}`, method: 'GET' }) // 根据用户ID获取登录日志
}
